import { Component, ViewChild } from '@angular/core';
import { SubAccountsService } from './sub-accounts.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TableSubAccountsComponent } from '../table-sub-accounts/table-sub-accounts.component';

@Component({
  selector: 'app-sub-accounts',
  templateUrl: './sub-accounts.component.html',
  styleUrls: ['./sub-accounts.component.scss'],
})
export class SubAccountsComponent {
  aReceber: number = 0;
  recebimento: number = 0;
  ticketMedioRecebimento: number = 0;
  conversao: number = 0;
  saque: number = 0;
  saquePendente: number = 0;
  saldoFinal: number = 0;

  extrato = new FormGroup({
    tipo: new FormControl<string>(''),
    status: new FormControl<string>(''),
    tipoBusca: new FormControl<string>(''),
    origem: new FormControl<string>(''),
    aplicacao: new FormControl<string>(''),
    valorFiltro: new FormControl<string>(''),
    initialDate: new FormControl<NgbDateStruct | null>(
      null,
      Validators.required
    ),
    endDate: new FormControl<NgbDateStruct | null>(null, Validators.required),
  });

  transactionTypes = [
    { name: 'common.general', value: '' },
    { name: 'common.deposit', value: 'DEPOSITO' },
    { name: 'common.withdraw', value: 'SAQUE' },
  ];
  statusList: any[] = [
    { name: 'Todos', value: '' },
    { name: 'Pendente', value: 'PENDENTE' },
    { name: 'Realizado', value: 'REALIZADO' },
    { name: 'Analise', value: 'ANALISE' },
  ];
  // originList: { name: string; value: string }[] = [];
  originList = [
    { name: 'Todos', value: '' },
    { name: 'Pix', value: 'PIX' },
    { name: 'Comissão', value: 'COMISSÃO' },
    { name: 'Cripto', value: 'CRIPTO' },
    { name: 'Taxa Bancária', value: 'TAXA BANCÁRIA' },
    { name: 'Reembolso', value: 'REEMBOLSO' },
    { name: 'Tef', value: 'TEF' }
  ];

  applicationList = [
    { name: 'Todos', value: '' },
    { name: 'common.web', value: 'WEB' },
    { name: 'common.api', value: 'API' }
  ];
  tipoBuscaList: any[] = [
    { name: 'common.description', value: 'personName' },
    { name: 'common.id', value: 'id' },
    { name: 'common.idempotencyKey', value: 'idempotencyKey' },
    { name: 'common.document', value: 'cpf' },
  ];

  originMap: any = {
    BRL: { flag: 'assets/flags/4x3/br.svg', gmtOffset: -3, name: 'Brasil' },
    MXN: { flag: 'assets/flags/4x3/mx.svg', gmtOffset: -6, name: 'México' },
    CLP: { flag: 'assets/flags/4x3/cl.svg', gmtOffset: -4, name: 'Chile' },
    PEN: { flag: 'assets/flags/4x3/pe.svg', gmtOffset: -5, name: 'Peru' },
    COP: { flag: 'assets/flags/4x3/co.svg', gmtOffset: -5, name: 'Colômbia' },
    PHP: { flag: 'assets/flags/4x3/ph.svg', gmtOffset: +8, name: 'Philippines' }
  };

  public accountOrigin: any;
  public isFilterColapsed = false;
  public isSubmitted = false;
  public isLoaded: boolean = false;
  public accountMultiDash: any;

  @ViewChild(TableSubAccountsComponent) table!: TableSubAccountsComponent;

  constructor(
    private subaccountsService: SubAccountsService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    this.extrato.controls.initialDate.setValue({
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
    });
    this.extrato.controls.endDate.setValue({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    });
    this.extrato.controls.status.setValue('REALIZADO');
    this.extrato.controls.tipoBusca.setValue('personName')
    this.loadAccountOrigin();
    this.loadAccountMultiDashboard();
  }

  onTableLoading(isLoading: boolean) {
    this.isLoaded = !isLoading;
  }

  onTableSwitched() {
    this.loadAccountOrigin();
    this.table.page = 1;
    this.table.loadData(this.extrato.controls.valorFiltro.value || '');
  }

  getEnum(): void {
    this.subaccountsService.getEnum()
      .then(resp => {
        this.originList = [
          { name: 'Todos', value: '' },
          ...resp.values.map((v: string) => ({ name: v, value: v }))
        ];
      });
  }

  loadAccountOrigin() {
    this.isLoaded = false;
    this.subaccountsService.getAccountOrigin().subscribe({
      next: (res) => this.accountOrigin = res,
      error: () => this.accountOrigin = null
    });
  }

  loadAccountMultiDashboard() {
    this.subaccountsService.getAccountMultiDashBoard().subscribe({
      next: (res) => this.accountMultiDash = res,
      error: () => this.accountMultiDash = null
    });
  }

  onAccountStatusChanged() {
    this.loadAccountMultiDashboard();
  }


  buscar() {
    this.table.page = 1;
    this.table.loadData(this.extrato.controls.valorFiltro.value || '');
  }

  async paste(): Promise<void> {
    try {
      const text = await navigator.clipboard.readText();

      this.extrato.controls.valorFiltro.setValue(text.trim());

    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  filterColapse() {
    this.isFilterColapsed = !this.isFilterColapsed;
  }

  downloadFile() {
    let dataInitial = this.extrato.controls.initialDate.value!;
    let dataFinal = this.extrato.controls.endDate.value!;

    let dateInitialFormat = new Date(
      dataInitial.year,
      dataInitial.month - 1,
      dataInitial.day
    );
    let dateFinalFormat = new Date(
      dataFinal.year,
      dataFinal.month - 1,
      dataFinal.day
    );
    this.subaccountsService
      .getCsvFile(
        dateInitialFormat,
        dateFinalFormat,
        this.extrato.controls.tipo.value!,
        this.extrato.controls.status.value!
      )
      .subscribe((value) => {
        let csvContent = decodeURIComponent(escape(atob(value)));
        const a = document.createElement('a');
        const blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;',
        });
        const url = window.URL.createObjectURL(blob);
        let company = this.authService.getCompany();
        a.href = url;
        a.download = `${company}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
  }
}
